import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetItmGroup/Main";
import Form from "./TbSetItmGroup/Form";

// Utils
import { getDataWithComp, getAlert } from "../../../utils/SamuiUtils";
import { InitialDataTbSetItmGroup } from "../../../model/InitialData/InitialDataTbSetItmGroup";

const TbSetItmGroup = () => {
    const [mode, setMode] = useState("");
    const [dataMasterList, setDataMasterList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [formData, setFormData] = useState(InitialDataTbSetItmGroup());

    useEffect(() => {
        const init = async () => {
            try {
                setMode("S");
                fetchRealtime();
            } catch (error) {
                getAlert("FAILED", error.message);
            }
        };
        init();
    }, []);

    const initialize = async () => {
        try {
            setMode("S");
            fetchRealtime();
        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

    const fetchRealtime = async () => {
        try {
            const masterList = await getDataWithComp(
                "Tb_Set_ItmGroup",
                "Order By Group_Id"
            );
            if (masterList && masterList.length > 0) {
                setDataMasterList(masterList);
            }
        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

    const onPageInsert = () => {
        setMode("I");
    };

    const onRowSelected = (item) => {
        setMode("U");
        setFormData({
            comp_id: item.Comp_Id,
            Group_Id: item.Group_Id,
            Group_Code: item.Group_Code,
            Group_Name: item.Group_Name,
            Group_Status: item.Group_Status,
            Doc_Type: item.Doc_Type,
        });
        setSelectedData(item);
    };

    return (
        <div className="TbSetItmGroup">
            <div className="wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="container">
                        <div className="page-inner">
                            {mode === "S" ? (
                                <Main
                                    masterList={dataMasterList}
                                    name={"ข้อมูลหมวดหมู่สินค้า"}
                                    onPageInsert={() => onPageInsert()}
                                    onRowSelected={(item) => onRowSelected(item)}
                                    callInitialize={fetchRealtime}
                                />
                            ) : (
                                <Form
                                    callInitialize={initialize}
                                    mode={mode}
                                    name={"ข้อมูลหมวดหมู่สินค้า"}
                                    formData={formData}
                                    setFormData={setFormData}
                                    selectedData={selectedData}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TbSetItmGroup;